export enum Pages {
  Learn = '/learn',
  Teach = '/teach',
  Classroom = 'team',
}
